/*
 * File: InstructorAvatarsSkeleton.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

/**
 * Skeleton loader for InstructorAvatars component
 * Shows 1-2 instructor placeholders
 */
export default function InstructorAvatarsSkeleton() {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
        <Skeleton width={100} />
      </Typography>
      <List dense disablePadding>
        {[1, 2].map((i) => (
          <ListItem key={i} disablePadding sx={{ mb: 1 }}>
            <ListItemAvatar sx={{ minWidth: 48 }}>
              <Skeleton variant="circular" width={40} height={40} />
            </ListItemAvatar>
            <Box flex={1}>
              <Skeleton width="60%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton width="40%" height={16} />
            </Box>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
